import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useOnboardingProfile } from '../hooks/useOnboarding.js';

/**
 * Tracker-first setup gate. The required path ends when deterministic
 * onboarding is complete; training and diet plans are deliberately not
 * prerequisites. Mode-specific pages render their own empty/setup states.
 */
export function RequireSetupComplete({ children }: { children: ReactNode }) {
  const location = useLocation();
  const onboarding = useOnboardingProfile();

  if (onboarding.isLoading) {
    return (
      <div className="empty-state card" role="status" aria-live="polite">
        <p>Loading…</p>
      </div>
    );
  }

  if (!onboarding.data?.completedAt) {
    return <Navigate to="/onboarding/mode" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
